import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DeloitteAiVjsPlayerComponent } from "./vjs-player";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
    declarations: [
        DeloitteAiVjsPlayerComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule
    ],
    exports: [
        DeloitteAiVjsPlayerComponent
    ],
    providers: [],
})
export class DeloitteAiVjsPlayerModule {}

